import { useMemo } from 'react';
import { ContentCardsContainer } from 'components/Container';
import { BlogCard } from './BlogCard';

import type { FC } from 'react';
import type { BlogPost } from 'types/blog/blogPost';

export const BlogCards: FC<{ entries: BlogPost[] }> = ({ entries }) => {
  const blogCards = useMemo(
    () => entries.map(entry => <BlogCard key={entry.id} entry={entry} />),
    [entries]
  );

  return (
    <ContentCardsContainer columns={3} gap={1}>
      {blogCards}
    </ContentCardsContainer>
  );
};
